
<ion-header class="menu-header">
  <ion-toolbar>
    <div class="ion-text-center">
      <img src="{{_appServices._themingService.currentLogo.value.logoUrl}}" class="w-35">
    </div>
    <ion-button (click)="closeModal()" slot="end" fill="clear" class="cancelbutton">
      <ion-icon (click)="closeModal()" color="tertiary" slot="icon-only" name="close"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-content class="white-background">
  <div class=" main-content">
    <h4 class="guideance">Guidance Notes</h4>
    <p  class="report-paragraph">{{instructionsData}}</p>
    <!-- <p class="report-paragraph">The Inventory will be checked at the end of the tenancy at which time any variances or discrepancies will be recorded. Missing or
      damaged items that are not considered as "fair wear and tear" will be the responsibility of the Tenant to pay for repair, replacement,
      making good, cleaning or any other required process. The following notes have been designed to assist you when handing the Property
      back to the Landlord at the check-out appointment. In order to protect your deposit, it is advisable that you read these guidelines and
      take the appropriate action.
    </p>
    <ul class="points-paragraph">
      <li>
        Ensure that the Property has been left in a good, clean condition throughout and all of your personal items have been completely removed.
      </li>
      <li>
        All items should be returned to exactly the same position as they are listed on the Inventory.
      </li>
      <li>
        All windows, mirrors and glass items should be cleaned and polished.
      </li>
      <li>
        All woodwork, skirting, dado rails, picture rails, frames, shelving, cabinets, etc., should be cleaned and polished.
      </li>
      <li>
        All soft furnishings such as carpets, curtains, rugs, bed linen, towels, throws and mattresses, etc., should be laundered/washed free of stains, ironed
        (where applicable) and left clean.
      </li>
      <li>
        All walls and ceilings should be dusted, wiped over (where necessary) and be free of excessive wear
      </li>
      <li>
        All kitchen cupboards should be cleaned and emptied of your food and belongings. Fridges and freezers should be emptied of food, cleaned
        thoroughly, defrosted, switched off and their doors left open. Cooker extractors should be cleaned and their filters changed.
      </li>
      <li>
        Bathrooms should be cleaned thoroughly and all sealant and grouting should be free of staining or mould.
      </li>
      <li>
        All light bulbs should be present and in working order.
      </li>
      <li>
        All picture hooks, tacks, screws, nails or other fittings installed by you should be removed and any damage made good.
      </li>
      <li>
        Any missing or damaged items should be replaced to match.
      </li>
      <li>
        A mail forwarding service should be set up by you to ensure that your post reaches you at your new address.
      </li>
    </ul> -->
  </div>
  
</ion-content>